/* eslint-disable */
(function($, Drupal, once) {

  Drupal.behaviors.mobileSearchFilter = {
    attach: function(context, settings) {

      const toggleFiltersResize = function() {
        const $body = jQuery('body');
        const $filterWrap = jQuery('.filter-wrap');
        var width = jQuery(window).width();
        if ($body.hasClass('no-scroll')) {
          $body.removeClass('no-scroll');
        }

        if (width > 992) {
          $filterWrap.show();
        }
        else if (!(document.activeElement.tagName.toLowerCase() === 'input')) {
          $filterWrap.hide();
        }
      };

      const mobileSearchFilterInit = function() {
        $('.block-views-exposed-filter-blockcontent-search-block').closest('.lb-region--left').addClass('filter-wrap');
        // Open filter.

        $(once('open-filter-processed', '#js-open-filter', context)).each(function() {
          jQuery(this).click(function(e) {
            jQuery('.filter-wrap').show();
            jQuery('body').addClass('no-scroll');
          });
        });

        // Close filter.
        $(once('close-filter-processed', '#js-close-filter', context)).each(function() {
          jQuery(this).click(function(e) {
            jQuery('.filter-wrap').hide();
            jQuery('body').removeClass('no-scroll');
          });
        });

        // Hide filter on mobile load.
        $(once('exposed-filter-processed', '#views-exposed-filter-blockproduct-search-block-1', context)).each(function() {
          jQuery('.lb-region--left').addClass('filter-wrap');

          // Add resize event listener
          $(window).on('resize', toggleFiltersResize);
        });

        $(once('exposed-filter-processed', '#views-exposed-filter-blocksku-search-block-1', context)).each(function() {
          jQuery('.lb-region--left').addClass('filter-wrap');

          // Add resize event listener
          $(window).on('resize', toggleFiltersResize);
        });
      };

      // Add a mutation observer, if childlist mutation call mobileSearchFilterInit
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'childList' && $('.block-inline-blockcontent-search').length) {
            mobileSearchFilterInit();
          }
        });
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });

      // Add DOMContentLoaded event listener
      $(document).ready(function() {
        mobileSearchFilterInit();
      });
    }
  };
})(jQuery, Drupal, once);